import { render, staticRenderFns } from "./ChargesRegistry.vue?vue&type=template&id=7a877c6c&scoped=true&"
import script from "./ChargesRegistry.vue?vue&type=script&lang=js&"
export * from "./ChargesRegistry.vue?vue&type=script&lang=js&"
import style0 from "./ChargesRegistry.vue?vue&type=style&index=0&id=7a877c6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a877c6c",
  null
  
)

export default component.exports